import { Component } from '@angular/core'
import { environment } from '@exchange/environment'
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser'

@Component({
  selector: 'app-users-list',
  templateUrl: './users-list.component.html',
  styleUrls: ['./users-list.component.scss'],
  standalone: false
})
export class UsersListComponent {
  iframeUrl: SafeResourceUrl

  constructor(private sanitizer: DomSanitizer) {
    this.iframeUrl = this.sanitizer.bypassSecurityTrustResourceUrl(
      `${environment.reactAppUrl}/users`
    )
  }
}
